// import * as React from "react";
// import Box from "@mui/material/Box";
// import MUISpeedDial from "@mui/material/SpeedDial";
// import SpeedDialIcon from "@mui/material/SpeedDialIcon";
// import SpeedDialAction from "@mui/material/SpeedDialAction";

// const SpeedDial = ({ value = [], options, ariaLabel, sx, onChange }) => {
//   const handleClick = (selectedValue) => {
//     // Ensure value is an array
//     let updatedValues = Array.isArray(value) ? [...value] : [];

//     if (updatedValues.includes(selectedValue)) {
//       // Remove the value if it is already selected
//       updatedValues = updatedValues.filter((val) => val !== selectedValue);
//     } else {
//       // Add the value if it is not selected
//       updatedValues.push(selectedValue);
//     }

//     if (onChange) {
//       onChange(updatedValues);
//     }
//   };

//   return (
//     <Box>
//       <MUISpeedDial
//         ariaLabel={ariaLabel || "SpeedDial example"}
//         // sx={{ position: "absolute", bottom: -100, right: 16 }}
//         icon={<SpeedDialIcon />}
//       >
//         {options.map((option) => (
//           <SpeedDialAction
//             key={option.value}
//             icon={<span>{option.label}</span>}
//             tooltipTitle={option.label}
//             onClick={() => handleClick(option.value)}
//             sx={{
//               ...sx,
//               backgroundColor: value.includes(option.value)
//                 ? "rgba(0, 0, 0, 0.08)"
//                 : "transparent",
//               borderRadius: "50%",
//               "&:hover": {
//                 backgroundColor: value.includes(option.value)
//                   ? "rgba(0, 0, 0, 0.15)"
//                   : "rgba(0, 0, 0, 0.04)",
//               },
//             }}
//           />
//         ))}
//       </MUISpeedDial>
//     </Box>
//   );
// };

// export default SpeedDial;

import * as React from "react";
import Box from "@mui/material/Box";
import MUISpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";

const SpeedDial = ({ value = [], options, ariaLabel, sx, onChange }) => {
  const [open, setOpen] = React.useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClick = (selectedValue) => {
    let updatedValues = Array.isArray(value) ? [...value] : [];

    if (updatedValues.includes(selectedValue)) {
      updatedValues = updatedValues.filter((val) => val !== selectedValue);
    } else {
      updatedValues.push(selectedValue);
    }

    if (onChange) {
      onChange(updatedValues);
    }
  };

  return (
    <Box
      sx={{
        height: 20,
        transform: "translateZ(0px)",
        flexGrow: 1,
        ...sx,
      }}
    >
      <MUISpeedDial
        ariaLabel={ariaLabel || "SpeedDial example"}
        sx={{
          position: "absolute",
        }}
        icon={<span>Hide</span>}
        direction="right"
        open={open} // Control open state
        onClick={handleToggle} // Toggle open/close on click
      >
        {options.map((option) => (
          <SpeedDialAction
            key={option.value}
            icon={<span>{option.value}</span>}
            tooltipTitle={option.label}
            onClick={() => handleClick(option.value)}
            sx={{
              backgroundColor: value.includes(option.value)
                ? "#5C75B1"
                : "transparent",
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: value.includes(option.value)
                  ? "#5C75B1"
                  : "transparent",
              },
            }}
          />
        ))}
      </MUISpeedDial>
    </Box>
  );
};

export default SpeedDial;
